
    export const travelCost = [{id:0,name:"Zone 1"},{id:1,name:"Zone 2"},{id:2,name:"Zone 3"},{id:3,name:"Zone 4"},
                                {id:4,name:"Zone 5"},{id:5,name:"Zone 6"}, {id:6,name:"Zone 7"} ,{id:7,name:"Zone 8"},
                                {id:8,name:"Zone 9"},{id:9,name:"Zone 10"},{id:10,name:"Zone 11"},{id:11,name:"Zone 12"},
                                {id:12,name:"Zone 13"}]

    export const movements = [{id:1,name:1},{id:2,name:2},{id:3,name:3},{id:4,name:4},{id:5,name:5}
                             ,{id:6,name:6},{id:7,name:7},{id:8,name:8},{id:9,name:9},{id:10,name:10},
                             {id:11,name:11},{id:12,name:12},{id:13,name:13},{id:14,name:14},{id:15,name:15}
                            ,{id:16,name:16},{id:17,name:17},{id:18,name:18},{id:19,name:19},{id:20,name:20}]

    export const travelZoneList = [{id:1,name:1},{id:2,name:2},{id:3,name:3},{id:4,name:4},{id:5,name:5},{id:6,name:6},
                 {id:7,name:7},{id:8,name:8},{id:9,name:9},{id:10,name:10},{id:11,name:11},{id:12,name:12},{id:13,name:13}]

export const noOfCans =  [{id:0,name:0},{id:1,name:1},{id:2,name:2},{id:3,name:3},{id:4,name:4},{id:5,name:5},{id:6,name:6},
      {id:7,name:7},{id:8,name:8},{id:9,name:9},{id:10,name:10},{id:11,name:11},{id:12,name:12},{id:13,name:13}]

       export const fumigantWarehouseLocation = [{value:'AKLBRNCH',label:'Auckland'},
        {value:'CHCMHF',label:'Christchurch MHF'},{value:'GENMHF',label:'Major Hazard Facility - Mount Maunganui'},{value:'MAPBRNCH',label:'Northport Branch'},
    {value:'NPEBRNCH',label:'Napier Branch'},{value:'NSNBRNCH',label:'Nelson'},{value:'SHED8MMU',label:'Shed 8 - Port of Tauranga'},
    {value:'WLGBRNCH',label:'Wellington Branch'}]

        
    export const mbDescription = [ {value:'MB-50KG',label:'MB BOTTLE 50KG '}, {value:'MB-100KG',label:'MB BOTTLE 100KG'}]
//added new Fumi
     export const alpDescription = [ {value:'ALP-FUMI (1kg)',label:'Fumitoxin 1kg Flasks'},{value:'ALP-FUMI',label:'Fumitoxin 1.5kg Flasks'},
        {value:'ALP-GENDRUM',label:'Genfume Blankets 3.4kg'}, {value:'ALP-PEST',label:'Pestphos 1.5kg Flasks'},
         {value:'ALP-QUICK',label:'QuickPhos 1.5kg Flasks'}
     ]
export const cssDescription = [{value:'IST005',label:'Barricade 1 x 1L'},{value:'IST037',label:'Barricade 5L'},{value:'IST020',label:'Callington 1-Shot'}]
export const efDescription = [ {value:'EFUME',label:'eFume Bottles'},{value:'ECO2FUME',label:'ECO2FUME'}, {value:'VPM279',label:'Vapormate Bottles 279FE (27kg per bottle)'}]

export const hcnDescription = [ {value:'HCN-TIN',label:'HCN Cyanosil'}]
export const macslayDescription = [ {value:'SLAYTF4A',label:'MAC Slay Transitional Facility Dual-Action Spray'}]
export const pestiDescription = [ {value:'PESTI',label:'Pestigas'}]

export const thermoFogDescription = [ {value:'TBA',label:'ThermoFog'}]
export const vapormateDescription = [ {value:'VPM279',label:'Vapormate Bottles 279FE (27kg per bottle)'},{value:'EFUME',label:'eFume Bottles'},{value:'ECO2FUME',label:'ECO2FUME'}]
export const sfDescription = [ {value:'SF-Pro',label:'Sulphuryl Fluride Fumigant (56.5KG per cylinder)'}]
export const vaporphosDescription = [ {value:'VAP-22KG',label:'Vaporph3os Fumigant (22KG per cylinder)'}]

   
  export const cubFunction = [
     {
       role: 'Boundry Left'
     },
     {
       role: 'Boundry Right'
     },
     {
       role: 'Boundry Direct'
     },
     {
       role: 'MSZ'
     }
   ];
//single is default
   export const applicationtype = [ {id:'Single',displayName:'Single'},{id:'Multiple',displayName:'Multiple'}]

   export const monitoringtype = [{id:'Crew Monitoring',displayName:'Crew Monitoring'},{id:'ITT',displayName:'ITT'}]

